import React, { useEffect, useState } from "react";
import InstagramIcon from "@mui/icons-material/Instagram";
import TwitterIcon from "@mui/icons-material/Twitter";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import YouTubeIcon from "@mui/icons-material/YouTube";
import LanguageIcon from "@mui/icons-material/Language";
import { Box, Typography, TextField, Button } from "@mui/material";
// import useWindowSize from "../../../hooks/useWindowSize";
import Grid from "@mui/material/Grid2";
import ImageUploader from "../../../components/common/ImageUploader";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import { get, patch } from "../../../services/apiService";
import { useParams } from "react-router-dom";
import { useAuth } from "../../../hooks/useAuth";
import i18next from "i18next";
import BackdropLoader from "../../../components/common/BackdropLoader";
import { uploadFile } from "../../../utils/utils";

const socialIcons = {
  instagram: <InstagramIcon sx={{ color: "#fff" }} />,
  twitter: <TwitterIcon sx={{ color: "#fff" }} />,
  linkedin: <LinkedInIcon sx={{ color: "#fff" }} />,
  youtube: <YouTubeIcon sx={{ color: "#fff" }} />,
  browser: <LanguageIcon sx={{ color: "#fff" }} />,
};

const FooterPreview = () => {
  // const { width } = useWindowSize();
  const { currentLang } = useAuth();
  const isArabic = i18next.language === "ar";
  const direction = currentLang === "en" ? "ltr" : "rtl";
  const [homeLinks, setHomeLinks] = useState([]);
  const [newHomeLink, setNewHomeLink] = useState("");
  const [quickLinks, setQuickLinks] = useState([]);
  const [newQuickLink, setNewQuickLink] = useState({ label: "", path: "" });
  const [socialMedia, setSocialMedia] = useState([]);
  const [translationsMap, setTranslationsMap] = useState({});
  const [socialUrl, setSocialUrl] = useState("");
  // const [editIndex, setEditIndex] = useState({ type: "", index: null });
  const [logoUrl, setLogoUrl] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const platforms = Object.keys(socialIcons);
  const nextPlatform = platforms[socialMedia.length % platforms.length];

  const addressIcons = {
    location: <LocationOnIcon sx={{ color: "#b0b0b0", fontSize: 20 }} />,
    email: <EmailIcon sx={{ color: "#b0b0b0", fontSize: 20 }} />,
    phone: <PhoneIcon sx={{ color: "#b0b0b0", fontSize: 20 }} />,
  };

  const addressInfo = [
    {
      icon: addressIcons.location,
      text: "3041 Alasaker St an nuzha Riyadh",
    },
    {
      icon: addressIcons.email,
      text: "landingpage.com.sa",
    },
    {
      icon: addressIcons.phone,
      text: "+966 531565156",
    },
  ];

  const userId = localStorage.getItem("userId");

  const addHomeLink = () => {
    if (newHomeLink) {
      setHomeLinks([...homeLinks, { label: newHomeLink, path: "#" }]);
      setNewHomeLink("");
    }
  };

  const addQuickLink = () => {
    if (newQuickLink.label && newQuickLink.path) {
      setQuickLinks([...quickLinks, newQuickLink]);
      setNewQuickLink({ label: "", path: "" });
    }
  };

  const updateQuickLink = (index, field, value) => {
    const updated = [...quickLinks];
    updated[index][field] = value;
    setQuickLinks(updated);
  };

  const addSocialMediaLink = () => {
    const platforms = Object.keys(socialIcons);
    const next = platforms[socialMedia.length % platforms.length];
    setSocialMedia([...socialMedia, { platform: next, url: socialUrl }]);
    setSocialUrl("");
  };

  const updateSocialMediaUrl = (index, url) => {
    const updated = [...socialMedia];
    updated[index].url = url;
    setSocialMedia(updated);
  };

  const { id: userSectionId } = useParams();

  const onLoading = () => {};

  const fetchContent = async () => {
    const response = await get(
      `users/${userId}/section/${userSectionId}`,
      {},
      onLoading,
    );
    const content = response?.data?.content || [];

    const img = content.find((item) => item.contentType === "img");
    // const headings = content.filter((item) => item.contentType === "h3");
    const lists = content.filter(
      (item) => item.contentType === "unorderedlistlink",
    );
    let socials = content.pop();

    const getTranslatedText = (item) => {
      return (
        item?.translation?.find((t) => t.languageCode === currentLang)
          ?.languageText || ""
      );
    };

    const parseLinks = (item) => {
      const text = getTranslatedText(item);
      try {
        return JSON.parse(text);
      } catch {
        return [];
      }
    };

    const updatedHomeLinks = parseLinks(lists[0]).map((home) => ({
      label: home.text,
      path: home.link,
    }));

    const updatedQuickLinks = parseLinks(lists[1]).map((home) => ({
      label: home.text,
      path: home.link,
    }));
    socials = parseLinks(socials);
    socials = socials.filter((obj) => Object.keys(obj).length !== 0);
    console.log("socials---------->", socials);
    setLogoUrl(getTranslatedText(img));
    setHomeLinks(updatedHomeLinks);
    setQuickLinks(updatedQuickLinks);
    setSocialMedia(socials);

    // ✅ Build translationMap using index for unorderedlistlink
    const translationMap = {};
    let unorderedIndex = 0;

    content.forEach((item) => {
      let key = "";

      if (item.contentType === "unorderedlistlink") {
        key = `unorderedlistlink_${unorderedIndex++}`;
      } else if (item.contentType === "socialLinks") {
        key = "socialLinks";
      } else if (item.contentType === "img") {
        key = "img";
      } else if (item.contentType === "h3") {
        key = `h3_${item.content}`;
      }

      translationMap[key] = item.translation || [];
    });

    setTranslationsMap(translationMap);
  };

  const handleSubmit = async () => {
    const getMergedTranslation = (key, updatedValue) => {
      let oldTranslations = translationsMap[key] || [];

      // If no old translations, create a new one for currentLang
      if (oldTranslations.length === 0) {
        oldTranslations = [
          {
            languageCode: currentLang,
            languageText:
              typeof updatedValue === "string"
                ? updatedValue
                : JSON.stringify(updatedValue),
          },
        ];
      }

      // Update or preserve translations
      const updatedTranslations = oldTranslations.map((t) =>
        t.languageCode === currentLang
          ? {
              ...t,
              languageText:
                typeof updatedValue === "string"
                  ? updatedValue
                  : JSON.stringify(updatedValue),
            }
          : t,
      );

      // 🔁 If only one translation remains, duplicate it for fallback (e.g., "ar" or "en")
      if (updatedTranslations.length === 1) {
        const fallbackLang = currentLang === "en" ? "ar" : "en";
        updatedTranslations.push({
          languageCode: fallbackLang,
          languageText: updatedTranslations[0].languageText,
        });
      }

      return updatedTranslations;
    };

    const contentArray = [
      {
        contentType: "img",
        content: logoUrl,
        translation: getMergedTranslation("img", logoUrl),
      },
      {
        contentType: "h3",
        content: "Home",
        translation: getMergedTranslation("h3_Home", "Home"),
      },
      {
        contentType: "h3",
        content: "Quick Links",
        translation: getMergedTranslation("h3_Quick Links", "Quick Links"),
      },
      {
        contentType: "unorderedlistlink",
        content: "Home",
        translation: getMergedTranslation(
          "unorderedlistlink_0",
          homeLinks.map((link) => ({
            text: link.label,
            link: link.path || "#",
          })),
        ),
      },
      {
        contentType: "unorderedlistlink",
        content: "Quick Links",
        translation: getMergedTranslation(
          "unorderedlistlink_1",
          quickLinks.map((link) => ({
            text: link.label,
            link: link.path || "#",
          })),
        ),
      },
      {
        contentType: "socialLinks",
        content: "Social links in json each object must contain text and url",
        translation: getMergedTranslation(
          "socialLinks",
          socialMedia.map((s) => ({ text: s.platform, url: s.url })),
        ),
      },
    ];

    const finalObject = { sectionContent: contentArray };
    console.log("Final Output", contentArray);

    await patch(
      `users/${userId}/section/${userSectionId}/content`,
      finalObject,
      {},
      onLoading,
    );
  };
  const handleImageUpload = async (event) => {
    console.log(
      "image upload handler is called---------------->",
      event.target.files[0],
    );
    const file = event.target.files[0];
    // if (!file) return;

    setIsLoading(true);
    try {
      const imageUrl = await uploadFile(file, onLoading);
      // if (!response?.url) throw new Error("Invalid response from server");
      setLogoUrl(imageUrl);

      // setImage(updatedImageObject);
    } catch (error) {
      console.error("Image upload failed:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchContent();
  }, [currentLang]);

  return (
    <Box dir={direction}>
      {/* Content Preview Section Starts Here */}
      <Grid
        container
        spacing={4}
        sx={{ backgroundColor: "#373737", padding: "5%" }}
      >
        <Grid item size={{ xs: 12, md: 4 }}>
          {/* <Box sx={{ textAlign: "center" }}> */}

          {logoUrl && (
            <img
              src={logoUrl}
              alt="Logo"
              style={{ width: "150px", height: "110px" }}
            />
          )}

          <Box
            sx={{
              mt: 2,
              display: "flex",
              flexWrap: "wrap",
              gap: 2,
              // justifyContent: "center",
            }}
          >
            {socialMedia.map((social, index) => (
              <Box
                key={index}
                sx={{ display: "flex", alignItems: "center", gap: 1 }}
              >
                {socialIcons[social.platform]}
                {/* <Typography sx={{ color: "#fff" }}>{social.url}</Typography> */}
              </Box>
            ))}
          </Box>
        </Grid>
        <Grid item size={{ xs: 12, md: 3 }}>
          <Typography sx={{ color: "#fff", mt: 2, mb: 2, fontSize: "20px" }}>
            {i18next.t("Home")}
          </Typography>
          {homeLinks.map((link, index) => (
            <Typography
              key={index}
              sx={{ color: "grey", fontSize: 17, mb: 0.3 }}
            >
              {link.label}
            </Typography>
          ))}
        </Grid>
        <Grid item size={{ xs: 12, md: 3 }}>
          <Typography sx={{ color: "#fff", mt: 2, mb: 2, fontSize: "20px" }}>
            {i18next.t("Quick Links")}
          </Typography>
          {quickLinks.map((link, index) => (
            <Typography
              key={index}
              sx={{ color: "grey", fontSize: 17, mb: 0.3 }}
            >
              {link.label}
            </Typography>
          ))}
          {/* </Box> */}
        </Grid>
        <Grid item size={{ xs: 12, md: 2 }}>
          <Typography sx={{ color: "#fff", mt: 2, mb: 2, fontSize: "20px" }}>
            {i18next.t("Address")}
          </Typography>
          {addressInfo.map((address, index) => {
            return (
              <Box sx={{ display: "flex", gap: 3, marginBottom: "3%" }}>
                {address.icon}
                <Typography key={index} sx={{ color: "grey", fontSize: 14 }}>
                  {i18next.t(address.text)}
                </Typography>
              </Box>
            );
          })}
          {/* </Box> */}
        </Grid>
      </Grid>
      {isLoading && <BackdropLoader />}
      {/* Content Preview Section Ends Here */}
      {/* {second section starts here} */}
      <Grid
        container
        spacing={4}
        sx={{ backgroundColor: "white", padding: "5%" }}
      >
        <Grid item size={{ xs: 12, md: 6 }}>
          <>
            <Typography sx={{ color: "black", mb: 1 }}>
              {i18next.t("Upload Logo")}
            </Typography>
            <ImageUploader
              logoUrl={logoUrl}
              setLogoUrl={setLogoUrl}
              onUpload={handleImageUpload}
            />
          </>
        </Grid>
        <Grid item size={{ xs: 12, md: 6 }}>
          <>
            <Typography sx={{ color: "black", mb: 1 }}>
              {i18next.t("Add Social Media")}
            </Typography>
            <Box sx={{ display: "flex", mb: 2 }}>
              <TextField
                fullWidth
                value={socialUrl}
                onChange={(e) => setSocialUrl(e.target.value)}
                size="small"
                placeholder={`Enter ${nextPlatform} URL`}
                sx={{
                  backgroundColor: "#fff",
                  borderRadius: 1,
                  mr: !isArabic && 1.5,
                  ml: isArabic && 1.5,
                }}
              />
              <Button variant="contained" onClick={addSocialMediaLink}>
                {i18next.t("Add")}
              </Button>
            </Box>
            {socialMedia.length > 0 &&
              socialMedia.map((social, index) => (
                <TextField
                  key={index}
                  fullWidth
                  size="small"
                  value={social.url}
                  onChange={(e) => updateSocialMediaUrl(index, e.target.value)}
                  placeholder={`${social.platform} URL`}
                  sx={{ backgroundColor: "#fff", borderRadius: 1, mb: 1 }}
                />
              ))}
          </>
        </Grid>
        <Grid item size={{ xs: 12, md: 6 }}>
          <>
            <Typography sx={{ color: "black", mt: 1 }}>
              {i18next.t("Add Home Link")}
            </Typography>
            <Box sx={{ display: "flex", mb: 2 }}>
              <TextField
                fullWidth
                size="small"
                value={newHomeLink}
                onChange={(e) => setNewHomeLink(e.target.value)}
                placeholder={i18next.t("New Home Link")}
                sx={{
                  backgroundColor: "#fff",
                  borderRadius: 1,
                  mr: !isArabic && 1.5,
                  ml: isArabic && 1.5,
                }}
              />
              <Button onClick={addHomeLink} variant="contained">
                {i18next.t("Add")}
              </Button>
            </Box>
            {homeLinks.map((link, index) => (
              <TextField
                key={index}
                fullWidth
                size="small"
                value={link.label}
                onChange={(e) => {
                  const updated = [...homeLinks];
                  updated[index].label = e.target.value;
                  setHomeLinks(updated);
                }}
                placeholder={i18next.t("Home Link Label")}
                sx={{ backgroundColor: "#fff", borderRadius: 1, mb: 1 }}
              />
            ))}
          </>
        </Grid>

        <Grid item size={{ xs: 12, md: 6 }}>
          <>
            <Typography sx={{ color: "black", mt: 1 }}>
              {i18next.t("Add Quick Link")}
            </Typography>
            <Box sx={{ display: "flex", mb: 2 }}>
              <TextField
                fullWidth
                size="small"
                value={newQuickLink.label}
                onChange={(e) =>
                  setNewQuickLink({ ...newQuickLink, label: e.target.value })
                }
                placeholder={i18next.t("Link Label")}
                sx={{
                  backgroundColor: "#fff",
                  borderRadius: 1,
                  mr: !isArabic && 1.5,
                  ml: isArabic && 1.5,
                }}
              />
              <TextField
                fullWidth
                size="small"
                value={newQuickLink.path}
                onChange={(e) =>
                  setNewQuickLink({ ...newQuickLink, path: e.target.value })
                }
                placeholder={i18next.t("Link URL")}
                sx={{
                  backgroundColor: "#fff",
                  borderRadius: 1,
                  mr: !isArabic && 1.5,
                  ml: isArabic && 1.5,
                }}
              />
              <Button onClick={addQuickLink} variant="contained">
                {i18next.t("Add")}
              </Button>
            </Box>
            {quickLinks.map((link, index) => (
              <Box key={index} sx={{ display: "flex", gap: 1, mb: 1 }}>
                <TextField
                  fullWidth
                  size="small"
                  value={link.label}
                  onChange={(e) =>
                    updateQuickLink(index, "label", e.target.value)
                  }
                  placeholder={i18next.t("Quick Link Label")}
                  sx={{ backgroundColor: "#fff", borderRadius: 1 }}
                />
                <TextField
                  fullWidth
                  size="small"
                  value={link.path}
                  onChange={(e) =>
                    updateQuickLink(index, "path", e.target.value)
                  }
                  placeholder="Quick Link URL"
                  sx={{ backgroundColor: "#fff", borderRadius: 1 }}
                />
              </Box>
            ))}
          </>
        </Grid>

        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            gap: 2,
            mt: 4,
            width: "100%",
          }}
        >
          <Button variant="outlined" color="secondary">
            {i18next.t("Cancel")}
          </Button>
          <Button variant="contained" onClick={handleSubmit}>
            {i18next.t("Save Changes")}
          </Button>
        </Box>
      </Grid>
      {/* second section ends here */}
    </Box>
  );
};

export default FooterPreview;
